module.exports = __webpack_public_path__ + "img/TvDip-logo_big.d63bcf.png";